import React, { useEffect, useState } from 'react';
import { Fingerprint, ScanFace, Clock } from 'lucide-react';
import { SuccessBottomSheet } from '../components/SuccessBottomSheet';
import { ErrorBottomSheet } from '../components/ErrorBottomSheet';
export function ScanPage() {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isScanning, setIsScanning] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  const handleScan = (method: 'fingerprint' | 'face') => {
    setIsScanning(true);
    // Simulate scan process
    setTimeout(() => {
      setIsScanning(false);
      // Randomly succeed or fail for demo
      if (Math.random() > 0.3) {
        setShowSuccess(true);
      } else {
        setShowError(true);
      }
    }, 1500);
  };
  return <div className="h-full flex flex-col p-6 pb-24" data-id="element-201">
      {/* Status Card */}
      <div className="bg-slate-800 rounded-2xl p-6 border border-slate-700 shadow-xl mb-8 text-center" data-id="element-202">
        <div className="inline-flex items-center space-x-2 bg-green-500/10 text-green-400 px-3 py-1 rounded-full text-xs font-medium mb-4 border border-green-500/20" data-id="element-203">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-204" />
          <span data-id="element-205">Scanner Ready</span>
        </div>

        <div className="text-5xl font-mono font-bold text-white tracking-wider mb-1" data-id="element-206">
          {currentTime.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </div>
        <div className="text-slate-400 font-medium" data-id="element-207">
          {currentTime.toLocaleDateString([], {
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        })}
        </div>
      </div>

      {/* Main Action Area */}
      <div className="flex-1 flex flex-col items-center justify-center space-y-8" data-id="element-208">
        <div className="relative" data-id="element-209">
          {isScanning && <div className="absolute inset-0 bg-blue-500/20 rounded-full animate-ping" data-id="element-210" />}
          <button onClick={() => handleScan('fingerprint')} disabled={isScanning} className={`relative w-48 h-48 rounded-full flex flex-col items-center justify-center border-4 transition-all transform active:scale-95 ${isScanning ? 'bg-slate-800 border-blue-500 text-blue-400' : 'bg-blue-600 border-blue-400 text-white shadow-[0_0_40px_-10px_rgba(37,99,235,0.5)] hover:bg-blue-500'}`} data-id="element-211">
            <Fingerprint size={64} strokeWidth={1.5} className="mb-2" data-id="element-212" />
            <span className="font-semibold text-lg" data-id="element-213">Tap to Scan</span>
          </button>
        </div>

        <div className="text-slate-500 text-sm font-medium" data-id="element-214">OR</div>

        <button onClick={() => handleScan('face')} disabled={isScanning} className="flex items-center space-x-2 bg-slate-800 text-slate-300 px-6 py-3 rounded-xl border border-slate-700 hover:bg-slate-700 hover:text-white transition-colors" data-id="element-215">
          <ScanFace size={20} data-id="element-216" />
          <span data-id="element-217">Use Face Recognition</span>
        </button>
      </div>

      {/* Feedback Sheets */}
      <SuccessBottomSheet isOpen={showSuccess} onClose={() => setShowSuccess(false)} data={{
      employeeName: 'Sarah Connor',
      time: currentTime.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      }),
      type: 'Time In'
    }} data-id="element-218" />

      <ErrorBottomSheet isOpen={showError} onClose={() => setShowError(false)} message="Fingerprint not recognized. Please try again or use face recognition." onRetry={() => {
      setShowError(false);
      handleScan('fingerprint');
    }} data-id="element-219" />
    </div>;
}